import { useEffect } from 'react';

import Seo from '../../seo/Seo';
import { STATIC_META } from '../../seo/metaConfig';
import { Contacts } from '../Home/components/Contacts';

// Отдельный адрес /contacts: тот же блок контактов, что и на главной,
// но со своими Title и Description.
export const ContactsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo {...STATIC_META.contacts} />
      <Contacts />
    </>
  );
};
